var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
    callback: _vm.visibilityChanged,
    once: true,
  }),expression:"{\n    callback: visibilityChanged,\n    once: true,\n  }"}],staticClass:"fit-me"},[_c('div',{ref:"fitted",staticClass:"fitted",style:(`font-size: ${_vm.fontSize}px;`)},[_vm._v(" "+_vm._s(_vm.localText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }